import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  // Only init in production and when DSN is provided
  if (!dsn || import.meta.env.DEV) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Capture 10% of transactions for performance monitoring (free tier friendly)
    tracesSampleRate: 0.1,
    // No session replay — too heavy for PWA tablets
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Ignore noisy browser errors that aren't actionable
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      /^Network Error$/,
      /^Failed to fetch$/,
    ],
    beforeSend(event) {
      // Strip PII from breadcrumbs — guard against non-array values (iOS/Chrome Mobile)
      try {
        const crumbs = event.breadcrumbs as any;
        if (crumbs && Array.isArray(crumbs.values)) {
          crumbs.values = crumbs.values.map((b: any) => ({
            ...b,
            message: b.message?.replace(/[\w.-]+@[\w.-]+\.\w+/g, '[email]'),
          }));
        }
      } catch { /* never let beforeSend itself throw */ }
      return event;
    },
  });
}

export { Sentry };
